<template>
  <v-card flat>
    <v-tabs
        v-model="subTab"
        background-color="transparent"
        grow
        show-arrows
    >
      <v-tab>
        <v-icon left>mdi-chart-line</v-icon>
        Depot
      </v-tab>
      <v-tab>
        <v-icon left>mdi-cash-minus</v-icon>
        Verkäufe
      </v-tab>
      <v-tab>
        <v-icon left>mdi-cash-multiple</v-icon>
        Dividenden
      </v-tab>
      <v-tab>
        <v-icon left>mdi-bank</v-icon>
        Konto
      </v-tab>

      <v-tab-item>
        <DepotView />
      </v-tab-item>
      <v-tab-item>
        <VerkaeufeView />
      </v-tab-item>
      <v-tab-item>
        <DividendenView />
      </v-tab-item>
      <v-tab-item>
        <KontoView />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import DepotView from "./DepotView";
import VerkaeufeView from "./VerkaeufeView";
import DividendenView from "./DividendenView";
import KontoView from "./KontoView";

export default {
  name: "FinanzenView",
  components: {DepotView, VerkaeufeView, DividendenView, KontoView},
  data: () => ({
    subTab: 0,
  }),
}
</script>
